export class MouldPerformanceData {
  public constructor(
    public cycleTime: number,
    public runtimeFactor: number,
    public numberOfElements: number
  ) {}
}
